export default __webpack_public_path__ + "static/media/OpenSans-Italic.a38e47c3.woff";